import React, { useEffect, useState } from 'react';
import { Select, Switch } from '@mui/material';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import "./LoginRegister.css"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = ({ setSidebarVisible }) => {

  useEffect(() => {
    if (setSidebarVisible) {
      setSidebarVisible(false);
    }
    return () => {
      if (setSidebarVisible) {
        setSidebarVisible(true);
      }
    };
  }, [setSidebarVisible]);

  const [userData, setUserData] = useState({
    username: '',
    password_hash: '',
    employee_id: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    if (type === 'checkbox') {
      setUserData((prevData) => ({
        ...prevData,
        [name]: checked ? 1 : 0,
      }))
    } else {
      setUserData({
        ...userData, [name]: value
      });
    }

  }


  //   const handleSubmit = async (e) => {
  //     e.preventDefault();

  //     if (!userData.username || !userData.employee_id || !userData.password_hash || !userData.confirmPassword) {
  //       setError('All fields are required.');
  //       return;
  //     }

  //     if (userData.password_hash !== userData.confirmPassword) {
  //       setError('Passwords do not match.');
  //       return;
  //     }

  //     console.log(userData);

  //     try {
  //       const response = await axios.post('http://localhost/admin_dashboard/api/insertuser.php', userData, {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       });

  //       console.log('Server response:', response.data);

  //       if (response.data.success) {
  //         alert('Registration successful! Redirecting to login...');
  //         navigate('/login'); // Redirect to login page
  //       } else {
  //         setError(response.data.message || 'Registration failed. Employee ID already exists.');
  //       }

  //     } catch (error) {
  //       setError('Registration failed. Please try again');
  //       console.error('Error in signing:', error);
  //     }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userData.username || !userData.employee_id || !userData.password_hash || !userData.confirmPassword) {
      toast.warning('All fields are required.');
      return;
    }

    if (userData.password_hash !== userData.confirmPassword) {
      toast.warning('Passwords do not match.');
      return;
    }

    try {
      const response = await axios.post(
        'http://localhost/admin_dashboard/api/register.php',
        {
          username: userData.username,
          employee_id: userData.employee_id,
          password_hash: userData.password_hash
        },
        {
          withCredentials: true, // Important for session cookies
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Server response:', response.data);

      if (response.data.success) {
        // Store session data in state/localStorage if needed
        localStorage.setItem('employee_id', response.data.employee_id);
        localStorage.setItem('session_id', response.data.session_id);

        // alert('Registration successful! Redirecting to dashboard...');
        toast.success("Registration successful")
        navigate('/home', { replace: true }); // Redirect to dashboard after registration
      } else {
        setError(response.data.message || 'Registration failed.');
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || 'Registration failed.');
      } else {
        toast.error('Network error. Please try again.');
      }
      console.error('Registration error:', error);
    }
  };


  return (
    <div>
      <ToastContainer autoClose={3000} position='top-right' hideProgressBar />
      <div className='signup template d-flex justify-content-center align-items-center vh-100 bg '>
        <div className='form_container p-5 rounded bg-white'>
          <form onSubmit={handleSubmit}>
            <h3 className='text-center mb-5'>Register</h3>

            <div className="mb-2">
              <label>Username</label>
              <input
                type="text"
                name='username'
                placeholder="Username"
                onChange={handleChange}
                className='form-control'
              />
              <br />
            </div>
            <div>
              <label>Employee ID</label>
              <input
                type='text'
                name='employee_id'
                placeholder='Employee ID'
                onChange={handleChange}
                className='form-control'
              />
              <br />
            </div>
            <div className='mb-2'>
              <label>Password</label>
              <input
                type="password"
                name="password_hash"
                placeholder="Password"
                onChange={handleChange}
                className="form-control"
              />
              <br />
            </div>
            <div className='mb-2'>
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <br />
            <div className='d-grid'>
              <button className="btn btn-dark" type="submit">
                Sign Up
              </button>
            </div>
            <p className='text-end mt-3'> Already Register?
              <Link to="/login" className='ms-2'>Login</Link>
            </p>

            <br />
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </form>
        </div>
        <br />


      </div>
    </div>
  );
};

export default Register;

